import {
  TGetInAppNotificationsResponse,
} from '@/generated/qmulus/axios/core.ts';
import {
  components,
} from '@/generated/qmulus/openapi.ts';

export type TEventType = Partial<TGetInAppNotificationsResponse['items'][number]['eventType']>;
export enum EEventType {
  ALARM_OCCURRED = 'alarm_occurred',
  JOB_FINISHED = 'job_finished',
  JOB_STARTED = 'job_started',
  TIMESERIES_LAG_DETECTED = 'timeseries_lag_detected',
  NEW_QMULUS_RELEASE = 'new_qmulus_release',
  MAINTENANCE_OCCURRENCE_STATE_CHANGED = 'maintenance_occurrence_state_changed',
}

export type TTranslationEventItem = {
  label: string,
  description: string,
};

export type TSeverityTranslation = Record<components['schemas']['AlarmEventSeverity'], string>;
export type TTranslationEvent = Record<TEventType, TTranslationEventItem>;
